export const startDualScreen = (open, close) => {
	const presentationRequest = new PresentationRequest(["/dualscreen"]);

	let presentationConnection;
	console.log("start dualscreen", presentationRequest);

	// Make this presentation the default one when using the "Cast" browser menu.
	navigator.presentation.defaultRequest = presentationRequest;
	presentationRequest
		.start()
		.then((connection) => {
			open(connection);
			console.log("Connected to " + connection.url + ", id: " + connection.id);
		})
		.catch(function (error) {
			console.log("error start dualscreen", error, presentationRequest, navigator.presentation);
		});

	presentationRequest.addEventListener("connectionavailable", (event) => {
		presentationConnection = event.connection;
		presentationConnection.addEventListener("close", () => {
			close();
		});
		presentationConnection.addEventListener("terminate", () => {
			close();
		});
		presentationConnection.addEventListener("message", (event) => {
			open(presentationConnection);
		});
	});
};

export const checkDualScreenAvailability = (setAvailability) => {
	let presentationRequest;
	try {
		presentationRequest = new PresentationRequest(["/dualscreen"]);
	} catch {
		setAvailability(false);
		return;
	}
	presentationRequest
		.getAvailability()
		.then((availability) => {
			setAvailability(availability.value);
			if (availability.value) {
				availability.addEventListener("change", function () {
					setAvailability(availability.value);
				});
			}
		})
		.catch((error) => {
			setAvailability(false);
		});
};
